<template>
    <div id="service-staff-setting" class="shadow-md rounded-item">
        <vx-card>
            <div class="setting-card-hidden">
                <div class="setting-card-scroll">
                    <h4 class="text-2xl font-bold mb-6">Standalone PAX Mode</h4>
                    <div class="flex align-center">
                        <vs-switch v-model="pax_standalone_active" class="my-6" @click.stop="updatePaxStandalone"/>
                        <span class="pl-5">This mode will allow Go POS to be used without the credit card terminal. After you turn it on, you will need to close and reopen the Go POS app</span>
                    </div>
                    <div class="rounded-item mt-6 p-4 text-center" style="background: #FDF7E8">
                        <span class="d-inline-block w-10/12 text-left">
                            <span class="font-bold text-underline">Notice:</span> Please remember disabling this mode when you use semi-integrated PAX along with Go POS app
                        </span>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>
<script>
export default {
    name: 'standalone-pax-mode',
    data() {
        return {
            pax_standalone_active: false,
            loaded_data_num: 0,
            isOpenLoading: false,
            action_type: ''
        }
    },
    watch: {
        loaded_data_num: {
            immediate: true,
            handler() {
                if(this.loaded_data_num >= 1) {
                    this.closeLoading();
                } else {
                    this.action_type = "Get list";
                    this.openLoadingInDiv();
                }
            }
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                    color: 'danger',
                    title: 'Notification',
                    text: this.action_type + ' Standalone PAX Mode Failed',
                    acceptText: 'OK'
                })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        updatePaxStandalone() {
            const obj = {
                key: 'config.pos.pax_standalone_active',
                value: !this.pax_standalone_active ? 1 : 0
            }
            this.action_type = 'Update';
            this.openLoadingInDiv();
            this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", obj).then(() => {
                this.closeLoading();
                this.$vs.notify({
                title:'Notification',
                text:'Update Standalone PAX Mode Success',
                color:'success',
                position:'top-right'})
            });
        }
    },
    created() {
        const obj = {
            key: 'config.pos.pax_standalone_active'
        }

        this.$store.dispatch("appSetting/GET_KEY_STORAGE" ,obj).then(() => {
            this.loaded_data_num++;
            let pax_standalone_active = this.$store.getters["appSetting/keyStorage"];
            this.pax_standalone_active = pax_standalone_active.value == 1 ? true : false;
        }).catch(() => {
            const obj = {
                key: 'config.pos.pax_standalone_active',
                value: 0
            }
            this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
                this.loaded_data_num++;
            })
        })
    }
}
</script>

